export const convertFileToBase64 = (file: File) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const dataUrl = reader.result as string;
      const base64String = dataUrl.split(',')[1];
      resolve(base64String);
    };
    reader.onerror = reject;
  });

export const statusCheck = (products: any) => {
  let stockLabel = '';
  let color = '';
  if (products.CRA?.isPassed === true) {
    color = 'green';
  } else {
    color = 'red';
  }

  return { color };
};

export const getReferenceByKey = (
  items: any[] | undefined,
  referenceId: string,
  key: string
): any | undefined => {
  if (!Array.isArray(items)) return undefined;
  return items.find((item) => item[key] === referenceId);
};

export const getFEDSAReferenceNumber = (items, referenceId) => {
  return items?.find((pl) => pl.fedsa_RefNum === referenceId);
};
export const getEUFEDSADDSRefNumSubmit = (items, referenceId) => {
  return items?.find((pl) => pl.fedsa_dds_RefNum === referenceId);
};
export const getEUSupplierReferenceNumber = (items, referenceId) => {
  return items?.find((pl) => pl.supplierRefNum === referenceId);
};
export const getEUFEDSARefNumSubmitPDF = (items, referenceId) => {
  return items?.find((pl) => pl.fedsa_RefNum === referenceId);
};

export const downloadPdfFile = (byte, pdfData) => {
  const binaryData = atob(byte);
  const byteArray = new Uint8Array(binaryData.length);
  for (let i = 0; i < binaryData.length; i++) {
    byteArray[i] = binaryData.charCodeAt(i);
  }
  const blob = new Blob([byteArray], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = pdfData.data.fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const downloadExeclFile = (byte, excelData) => {
  const binaryData = atob(byte);
  const byteArray = new Uint8Array(binaryData.length);
  for (let i = 0; i < binaryData.length; i++) {
    byteArray[i] = binaryData.charCodeAt(i);
  }
  const blob = new Blob([byteArray], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = excelData.data.fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
